import React, {useRef} from 'react';

import Container from '../components/Container';
import Layout from '../components/Layout/Layout';

import * as styles from './contact.module.css';

const ContactPage = (props) => {
    let historyRef = useRef();

    return (
        <Layout disablePaddingBottom>
            <div className={styles.root}>

                <Container spacing={'min'}>
                    <div className={styles.detailContainer} ref={historyRef}>
                        <h3>
                            Contact Us
                        </h3>
                        <br/>
                        <p>
                            Have questions or need assistance? Feel free to email us anytime at porthos.du.vallon@outlook.com . We're here to help and typically respond within 24 hours.
                        </p>
                        <br/>
                        <br/>
                        <p>
                            <b>Contact E-mail:</b> porthos.du.vallon@outlook.com
                        </p>
                    </div>
                </Container>

            </div>
        </Layout>
    );
};

export default ContactPage;
